import { useAppDispatch } from 'src/v2/store/hooks'

import { navigateToRoute } from '../actions/routing.actions'
import {
  NavigationOptions,
  RouteKey,
  RouteParams,
} from '../types/routing.types'

export const useAppNavigation = () => {
  const dispatch = useAppDispatch()

  const navigateTo = <T extends RouteKey>(
    routeKey: T,
    params?: RouteParams[T],
    options: NavigationOptions = {},
  ) => {
    dispatch(
      navigateToRoute({
        routeKey,
        params,
        options,
      }),
    )
  }

  const replaceTo = <T extends RouteKey>(
    routeKey: T,
    params?: RouteParams[T],
    options: NavigationOptions = {},
  ) => {
    navigateTo(routeKey, params, { ...options, replace: true } as any)
  }

  const push = (
    path: string,
    options: {
      includeOrgPrefix?: boolean
      hardRedirect?: boolean
    } = {},
  ) => {
    dispatch(
      navigateToRoute({
        routeKey: 'CUSTOM_PATH' as RouteKey,
        params: { path } as any,
        options,
      }),
    )
  }

  return {
    navigateTo,
    replaceTo,
    push,
  }
}
